import {
  UPDATE_GALLERY,
  PARSE_HARMONY_GALLERY,
  GET_GALLERY_WITH_FALLBACKS,
} from "./actionTypes";

export const updateGallery = ({ assets }) => ({
  type: UPDATE_GALLERY,
  assets,
});

export const parseHarmonyGallery = (assets) => ({
  type: PARSE_HARMONY_GALLERY,
  harmonyGallery: assets,
});

export const getGalleryWithFallbacks = () => ({
  type: GET_GALLERY_WITH_FALLBACKS
});

const getGallery = () => (dispatch) => {
  // handled by gallerySaga
  dispatch(getGalleryWithFallbacks());
};

export default getGallery;
